import { Product } from '@notino/web-tracking';

import { dispatchTrackingEvent } from '@context/tracking/utils';

interface WishlistTotalValues {
  wishlistTotalLists: number;
  wishlistTotalProducts: number;
}

export interface TrackCreateNewListArgs extends WishlistTotalValues {
  interaction: 'wishlist_new' | 'move_button' | 'product_add';
}
export interface TrackDeleteListArgs extends WishlistTotalValues {
  interaction: 'wishlist_list' | 'wishlist_detail';
}
export interface TrackMultiAddToCartArgs {
  products: Product[];
  productCount: number;
}

export const trackCreateNewList = ({
  interaction,
  wishlistTotalLists,
  wishlistTotalProducts,
}: TrackCreateNewListArgs) => {
  dispatchTrackingEvent({
    event: 'wishlist_list_created',
    wishlist: {
      interaction,
      wishlist_total_lists: wishlistTotalLists,
      wishlist_total_products: wishlistTotalProducts,
    },
    _clear: true,
  });
};

export const trackDeleteList = ({
  interaction,
  wishlistTotalLists,
  wishlistTotalProducts,
}: TrackDeleteListArgs) => {
  dispatchTrackingEvent({
    event: 'wishlist_list_deleted',
    wishlist: {
      interaction,
      wishlist_total_lists: wishlistTotalLists,
      wishlist_total_products: wishlistTotalProducts,
    },
    _clear: true,
  });
};

export const trackMultiAddToCart = ({
  products,
  productCount,
}: TrackMultiAddToCartArgs) => {
  dispatchTrackingEvent({
    event: 'multi_add_to_cart',
    add: {
      product_count: productCount,
      products,
    },
    _clear: true,
  });
};

export const trackEmptyWishList = ({
  timing,
  mode,
}: {
  timing: number;
  mode: 'default' | 'custom';
}) => {
  dispatchTrackingEvent({
    event: 'wishlist_click',
    wishlist: {
      name: 'go_to_shop',
      interaction: 'button',
      timing,
      mode,
    },
  });
};

export const trackOpenWishList = ({
  wishlistTotalLists,
  wishlistTotalProducts,
}: WishlistTotalValues) => {
  dispatchTrackingEvent({
    event: 'wishlist_open',
    wishlist: {
      wishlist_total_lists: wishlistTotalLists,
      wishlist_total_products: wishlistTotalProducts,
      type: 'lists',
    },
    _clear: true,
  } as unknown as Parameters<typeof dispatchTrackingEvent>[0]);
};
